/**
 * These definitions are not currently available in the generated Liquid Docs
 * so we're hardcoding them here in the interim.
 */
export const DEFAULT_COMPLETION_OPTIONS: { [key: string]: string } = {
  type: "The type (name) of an existing theme block in your theme’s /blocks folder. Only applicable when `content_type` is 'block'.",
  id: "A unique identifier and literal string within the section or block that contains the static blocks. Only applicable when `content_type` is 'block'.",
  closest: 'A path that provides a way to access the closest resource of a given type.',
};
